<template>
  <div
    id="app"
    :class="{
      'guide-is-active': isGuideActive,
      'landing-page': isLandingPage,
    }"
  >
    <el-header>
      <custom-menu />
    </el-header>
    <el-main
      :class="{
        'is-mobile': isMobile,
      }"
    >
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </el-main>
    <el-footer height="60">
      <span>Обазривко</span>
      <!-- <span class="el-footer-year">{{ new Date().getFullYear() }}.</span> -->
      <span class="el-footer-usage">Сва права задржана</span>
    </el-footer>
  </div>
</template>
<script>
import CustomMenu from "./components/layout/CustomMenu.vue";
import MobileDetect from "mobile-detect";
import * as ROUTES from "./routes/routes";

export default {
  name: "app",
  components: {
    CustomMenu,
  },
  data() {
    return {
      isGuideActive: false,
      isMobile: false,
      isLandingPage: false,
      ROUTES,
    };
  },
  mounted() {
    const mobileDetect = new MobileDetect(window.navigator.userAgent);
    this.isMobile = mobileDetect.mobile();

    this.isLandingPage = this.$router.currentRoute.name === ROUTES.HOME_PAGE;

    this.$store.dispatch("checkIfUserIsLoggedIn");
    this.$router.afterHooks.push((state) => {
      this.isLandingPage = state.name === ROUTES.HOME_PAGE;
      this.isGuideActive = state.name === ROUTES.EXAMPLE_360_PAGE;
    });
  },
};
</script>

<style lang="scss">
$--color-white: #fff;
$--color-primary: #d6efff !default;
$--color-primary-light-1: mix(
  $--color-white,
  $--color-primary,
  10%
) !default; /* 53a8ff */
$--color-primary-light-2: mix(
  $--color-white,
  $--color-primary,
  20%
) !default; /* 66b1ff */
$--color-primary-light-3: mix(
  $--color-white,
  $--color-primary,
  30%
) !default; /* 79bbff */
$--color-primary-light-4: mix(
  $--color-white,
  $--color-primary,
  40%
) !default; /* 8cc5ff */
$--color-primary-light-5: mix(
  $--color-white,
  $--color-primary,
  50%
) !default; /* a0cfff */
$--color-primary-light-6: mix(
  $--color-white,
  $--color-primary,
  60%
) !default; /* b3d8ff */
$--color-primary-light-7: mix(
  $--color-white,
  $--color-primary,
  70%
) !default; /* c6e2ff */
$--color-primary-light-8: mix(
  $--color-white,
  $--color-primary,
  80%
) !default; /* d9ecff */
$--color-primary-light-9: mix(
  $--color-white,
  $--color-primary,
  90%
) !default; /* ecf5ff */

$--color-success: #67c23a !default;
$--color-warning: #e6a23c !default;
$--color-danger: #f56c6c !default;
$--color-info: #909399 !default;

html,
body {
  height: 100%;
}

body {
  margin: 0;
  font-family: "Roboto", sans-serif;
}
#app {
  background: $--color-primary-light-5;
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.el-header {
  padding: 0 !important;
}

.el-footer {
  height: 60px;
  padding: 0;
  background-color: #409eff;
  color: $--color-white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  span {
    font-size: 1.4rem;
  }

  .el-footer-year {
    display: inline;
    font-size: 0.8rem;
  }

  .el-footer-usage {
    font-size: 0.8rem;
  }
}

.el-main {
  overflow: hidden !important;
  flex: 2;
  display: flex !important;
}

// panellum fullscreen active
.guide-is-active {
  .el-main {
    padding: 0;
  }

  .el-footer {
    display: none;
  }

  .el-header {
    display: none;
  }
}

.s-guide {
  flex: auto;
  position: relative;
  padding: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.app-guide-link {
  position: absolute;
  color: #d6efff;

  @media screen and (max-width: 600px) {
    position: relative;
    font-size: 10px;
  }
}
</style>
